export enum RootPageAttributes {
  PATH = 'path',
  BASE_SITE_ID = 'baseSiteId',
}

export const rootPageInitialContent = {
  [RootPageAttributes.BASE_SITE_ID]: 'de',
};
